const prettier = require("prettier/standalone");
const parserhtml = require("prettier/parser-html");

export function UUID() {
    return 'xxxx-xxxxxx-xxxxxx'.replace(/[xy]/g, function (c) {
        var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
    });
}


HTMLElement.prototype.setPosition = function (x, y) {
    this.style.left = typeof x === 'number' ? x + 'px' : x;
    this.style.top = typeof y === 'number' ? y + 'px' : y;
}

HTMLElement.prototype.setMargin = function (x, y) {
    this.style.marginLeft = typeof x === 'number' ? x + 'px' : x;
    this.style.marginTop = typeof y === 'number' ? y + 'px' : y;
}

HTMLElement.prototype.getPosition = function () {
    return {
        x: this.style.left.split('px')[0],
        y: this.style.top.split('px')[0],
    }
}

HTMLElement.prototype.getOffSet = function () {
    return {
        x: this.offsetLeft,
        y: this.offsetTop,
    }
}

HTMLElement.prototype.setSize = function (width, height) {
    this.style.width = typeof width === 'number' ? width + 'px' : width;
    this.style.height = typeof height === 'number' ? height + 'px' : height;
}

HTMLElement.prototype.setHeight = function (height) {
    this.style.height = typeof height === 'number' ? height + 'px' : height;
}

HTMLElement.prototype.getSize = function () {
    return {
        width: this.style.width.split('px')[0],
        height: this.style.height.split('px')[0],
    }
}


HTMLElement.prototype.list = function () {
    const list = Array.from(this.children);
    return list ? list : [];
}

HTMLCollection.prototype.forEach = function (callback) {
    const list = Array.from(this);
    list.forEach((a, b, c) => callback(a, b, c));
}


HTMLCollection.prototype.list = function () {
    const list = Array.from(this);
    return list ? list : [];
}

NodeList.prototype.list = function () {
    const list = Array.from(this);
    return list ? list : [];
}

NodeList.prototype.removeClass = function (cls) {
    this.list().forEach((item) => {
        item.classList.remove(cls)
    })
}


HTMLElement.prototype.pretty = function () {
    this.removeAttribute('hidden');
    return prettier.format(`${this.innerHTML}`, { canSelfClose: false, parser: "html", plugins: [parserhtml] });
}

HTMLElement.prototype.removeMetaData = function () {
    const clone = this.cloneNode(true);
    clone.removeAttribute('hidden');
    clone.querySelectorAll('*').forEach((item) => {
        item.removeAttribute('id');
        item.classList.remove('min');
        item.classList.remove('outline');
        item.classList.remove('outline-select');
    });
    return clone;
}

HTMLElement.prototype.toHtml = function (name) {
    const clone = this.removeMetaData();
    const template = `<!DOCTYPE html>
<html lang="en">

<head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title>${name}</title>
    <link href="https://unpkg.com/tailwindcss@^1.0/dist/tailwind.min.css" rel="stylesheet">
</head>

<body>
${clone.innerHTML}
</body>

</html>
    `
    return prettier.format(`${template}`, { canSelfClose: false, parser: "html", plugins: [parserhtml] });
}

HTMLElement.prototype.toVue = function (name) {
    const clone = this.removeMetaData();

    const template = `
    <template>
        ${clone.innerHTML}
    </template>
    <script>
        export default {
            name:'${name}',
            data() {
                return {};
            },
            created(){},
            mounted(){},
            computed:{},
            methods:{}
        }
    </script>
    <style></style>
    `;
    return prettier.format(`${template}`, { canSelfClose: false, parser: "html", plugins: [parserhtml] });
}

HTMLElement.prototype.toReact = function (name) {
    const clone = this.removeMetaData();
    clone.querySelectorAll("*").forEach((item) => {
        const css = item.getAttribute('class');
        item.setAttribute('className', css);
        item.removeAttribute('class');
    });
    const html = prettier.format(`${clone.innerHTML}`, { canSelfClose: false, parser: "html", plugins: [parserhtml] });

    const template = `class ${name} extends React.Component {
        constructor(props){
            super(props);
        }
        render() {
          return (${html});
        }
    }
    `;
    return template;
}

HTMLElement.prototype.toAngular = function (name) {
    const clone = this.removeMetaData();
    const html = prettier.format(`${clone.innerHTML}`, { canSelfClose: false, parser: "html", plugins: [parserhtml] });

    const template = `import { Component, OnInit, Input } from '@angular/core';
    
    const html = \`${html}\`;

    @Component({
      selector: 'app-${name.toLowerCase()}',
      templateUrl: html,
    })
    export class ${name}Component implements OnInit {
    
      constructor() { }
    
      ngOnInit() {
      }
    
    }
    `;
    return template;
}

HTMLElement.prototype.toSave = function (withParent = false) {
    this.removeAttribute('hidden');
    const div = document.createElement('div');
    div.appendChild(this.cloneNode(true));
    if (withParent) {
        return `${div.innerHTML}`;
    } else {
        return `${this.innerHTML}`;
    }
}

HTMLElement.prototype.isSelected = function () {
    return Array.from(this.classList).some((item) => item === 'outline-select')
}

HTMLElement.prototype.isDiv = function () {
    return this.localName == 'div'
}

HTMLElement.prototype.isImage = function () {
    return this.localName == 'img'
}

HTMLElement.prototype.isInput = function () {
    return this.localName == 'input'
}

Object.defineProperty(Object.prototype, 'collapsed', {
    writable: true,
    value: false
})

Object.defineProperty(Object.prototype, 'toggle', {
    writable: true,
    value: function () {
        this.collapsed = !this.collapsed;
    }
})

Object.defineProperty(Object.prototype, 'show', {
    value: function () {
        this.collapsed = true;
    }
})

Object.defineProperty(Object.prototype, 'hide', {
    value: function () {
        this.collapsed = false;
    }
})

// Array.prototype.isShow = false;
// Array.prototype.toggle = function () {
//     this.isShow = !this.isShow;
// };
// Array.prototype.show = function () {
//     this.isShow = true;
// };
// Array.prototype.hide = function () {
//     this.isShow = false;
// };


String.prototype.hasNumber = function () {
    return /[100-1000]/.test(this);
}

HTMLElement.prototype.parse = function (htmlString, withParent = false) {
    this.innerHTML = htmlString.trim();
}

HTMLElement.prototype.empty = function () {
    this.innerHTML = '';
}

HTMLElement.prototype.parents = function () {
    const list = [];
    let parent = this;
    while (parent && parent.id !== 'wrapper') {
        list.push(parent);
        parent = parent.parentNode;
    }
    list.reverse();
    let child = this;
    while (child.children.length) {
        child = child.children[0];
        list.push(child);
    }
    return list;
}


// SELECTED NODE 
// Array.prototype.
Object.defineProperty(Array.prototype, "classList", {
    get: function () {
        return {
            add: (str) => {
                this.forEach((item) => item.classList.add(str))
            },
            remove: (str) => {
                this.forEach((item) => item.classList.remove(str))
            }
        }
    }
});

Object.defineProperty(Array.prototype, "classListArray", {
    get: function () {
        return this.flatMap((item) => Array.from(item.classList))
    }
});

Object.defineProperty(Array.prototype, "parents", {
    get: function () {
        return () => {
            return []
        }
    }
});

Object.defineProperty(Array.prototype, "appendChild", {
    get: function () {
        return (child) => {
            if (child instanceof Array) {
                this.forEach((item) => child.forEach(ch => item.appendChild(ch.cloneNode(true))))
            } else {
                this.forEach((item) => item.appendChild(child.cloneNode(true)))
            }
        }
    }
});

Object.defineProperty(Array.prototype, "deleteNode", {
    get: function () {
        return () => {
            this.forEach((item) => {
                if (item.id !== 'wrapper') {
                    const parent = item.parentNode;
                    parent.removeChild(item);
                }
            });
        }
    }
});

Object.defineProperty(Array.prototype, "innerText", {
    set: function (value) {
        this.forEach((item) => item.innerText = value)
    }
});

Object.defineProperty(Array.prototype, "setAttribute", {
    get: function () {
        return (attr, value) => {
            this.forEach((item) => item.setAttribute(attr, value))
        }
    }
});


Object.defineProperty(Array.prototype, "setBackgroundImage", {
    get: function () {
        return (value) => this.forEach((item) => {
            if (item.style.backgroundImage === value) {
                item.style.backgroundImage = '';
            } else {
                item.style.backgroundImage = value;
            }
        })
    }
});


Object.defineProperty(Array.prototype, "cloneNode", {
    get: function () {
        return (value) => this.map((item) => item.cloneNode(value))
    }
});

Object.defineProperty(Array.prototype, "nodeName", {
    get: function () {
        return this[0].nodeName;
    }
});